import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Partner } from '../models/partner';
import { RemovePartnerResult } from '../models/remove-partner-result';

@Injectable()
export class PartnerService {

  get loggedInPartner(): Observable<Partner> {
    throw new Error('Method not implemented.');
  }

  createPartner(partner: Partner, password: string, sendEmail: boolean = true): Observable<Partner> {
    throw new Error('Method not implemented.');
  }

  registerPartnerAuthorization(partnerId: number, email: string, password: string): Observable<Partner> {
    throw new Error('Method not implemented.');
  }

  updatePartner(partner: Partner): Observable<Partner> {
    throw new Error('Method not implemented.');
  }

  getChildren(): Observable<Partner[]> {
    throw new Error('Method not implemented.');
  }

  createChild(child: Partner): Observable<Partner> {
    throw new Error('Method not implemented.');
  }

  updateChild(child: Partner): Observable<Partner> {
    throw new Error('Method not implemented.');
  }

  removeChild(child: Partner): Observable<boolean> {
    throw new Error('Method not implemented.');
  }

  removeLoggedInPartner(password: string): Observable<RemovePartnerResult> {
    throw new Error('Method not implemented.');
  }

  uploadPhotoToField(photo: string, field: string): Observable<boolean> {
    throw new Error('Method not implemented.');
  }
}
